import { render, staticRenderFns } from "./AdvDataSourceBlock.vue?vue&type=template&id=205ea32b"
import script from "./AdvDataSourceBlock.vue?vue&type=script&lang=js"
export * from "./AdvDataSourceBlock.vue?vue&type=script&lang=js"
import style0 from "./AdvDataSourceBlock.vue?vue&type=style&index=0&id=205ea32b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports